export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sun-line text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap font-heading">
                向日葵视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              向日葵视频提供榴莲视频、红杏视频等平台免费高清在线观看服务，
              涵盖电影、电视剧、综艺、动漫等海量资源，播放流畅不缓冲，
              无需注册即可畅享极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading whitespace-nowrap">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#hero"
                  onClick={(e) => handleNavClick(e, '#hero')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  onClick={(e) => handleNavClick(e, '#features')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  特色优势
                </a>
              </li>
              <li>
                <a
                  href="#cards"
                  onClick={(e) => handleNavClick(e, '#cards')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  精选推荐
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  onClick={(e) => handleNavClick(e, '#faq')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  常见问题
                </a>
              </li>
              <li>
                <a
                  href="#app"
                  onClick={(e) => handleNavClick(e, '#app')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  移动观看
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading whitespace-nowrap">
              内容板块
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#index"
                  onClick={(e) => handleNavClick(e, '#index')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  热门专题
                </a>
              </li>
              <li>
                <a
                  href="#ranking"
                  onClick={(e) => handleNavClick(e, '#ranking')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  热度榜单
                </a>
              </li>
              <li>
                <a
                  href="#media"
                  onClick={(e) => handleNavClick(e, '#media')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  精彩推荐
                </a>
              </li>
              <li>
                <a
                  href="#updates"
                  onClick={(e) => handleNavClick(e, '#updates')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  最新动态
                </a>
              </li>
              <li>
                <a
                  href="#comments"
                  onClick={(e) => handleNavClick(e, '#comments')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  用户评价
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading whitespace-nowrap">
              合作伙伴
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 向日葵视频 - 免费高清在线观看平台。仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer"
            >
              关于我们
            </a>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer"
            >
              联系我们
            </a>
            <a
              href="#faq"
              onClick={(e) => handleNavClick(e, '#faq')}
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer"
            >
              帮助中心
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}